module.exports = __webpack_public_path__ + "img/pink-purse.c7c473db.jpg";